import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function Copyright() {
  return (
    <Typography
      variant="body2"
      align="center"
      sx={{ mt: 5 }}
    >
      {"Copyright © "}
      <Link color="inherit" to="https://qazando.com.br/">
        Qazando
      </Link>
      {" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default Copyright;